import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/resource/importer/resourceImporterActions';

export default importerReducers(actions);
